module.exports = __webpack_public_path__ + "img/14.152e8920.png";